export default __webpack_public_path__ + "static/media/logo.872f5c6e.png";